import Vue from 'vue'
import {commonFetch, apiAx} from '../common'

export default {
  namespaced: true,
  state: {
    data: {
      surchargeTypes: [],
      measureUnits: []
    }
  },
  mutations: {
    SET_DATA: (state, params) => {
      Vue.set(state.data, params.entity, params.data)
    }
  },
  actions: {
    fetch: commonFetch(apiAx),
    importExcel: (context, formData) => {
      return apiAx.post(
        '/import-excel',
        formData,
        {
          timeout: 180000,
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      )
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/admin.js